import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAlerts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/alerts', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAlert(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/alerts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addAlert(ctx, alert) {
      return new Promise((resolve, reject) => {
        axios
          .post('/alerts', alert)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateAlert(ctx, alert) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/alerts/${alert.id}`, alert)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteAlert(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/alerts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    exportAlertConfig(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/alerts/export', { params: { id } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
